import ProductDescription from './ProductDescription'

const CornMasaFlourProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '016',
  IsBroadband: false,
  CookingType: '',
  Size: '',
}

export default CornMasaFlourProduct
